module.exports = __webpack_public_path__ + "static/indihome-a4f9928b93e83f66b1fd451098c9ac87.jpg";